import { render, staticRenderFns } from "./ForwardAllEmails.vue?vue&type=template&id=cea9fda2&scoped=true&"
import script from "./ForwardAllEmails.vue?vue&type=script&lang=js&"
export * from "./ForwardAllEmails.vue?vue&type=script&lang=js&"
import style0 from "./ForwardAllEmails.vue?vue&type=style&index=0&id=cea9fda2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea9fda2",
  null
  
)

export default component.exports